import PortalBreadcrumb from "../../admin-shared/PortalBreadcrumb";

export default function Breadcrumb() {
  return <PortalBreadcrumb portalBasePath="/naturals/executive" />;
}
